import type { ReactNode } from "react";
import type { StyleProp, TextStyle, ViewStyle } from "react-native";
import type { HapticStyle } from "../haptics";
import { VelvetPrimaryButton } from "./VelvetPrimaryButton";

export type DialogPrimaryButtonProps = {
  label: string;
  onPress: () => void;
  disabled?: boolean;
  loading?: boolean;
  /** Set when used inside a row with sibling buttons. Omit for standalone (full-width). */
  flex?: number;
  leading?: ReactNode;
  icon?: ReactNode;
  trailing?: ReactNode;
  fullWidth?: boolean;
  hapticStyle?: HapticStyle | null;
  style?: StyleProp<ViewStyle>;
  contentStyle?: StyleProp<ViewStyle>;
  textStyle?: StyleProp<TextStyle>;
};

export function DialogPrimaryButton({
  label,
  onPress,
  disabled = false,
  loading = false,
  flex,
  leading,
  icon,
  trailing,
  fullWidth,
  hapticStyle = "buzz",
  style,
  contentStyle,
  textStyle,
}: DialogPrimaryButtonProps) {
  return (
    <VelvetPrimaryButton
      label={label}
      onPress={onPress}
      disabled={disabled}
      loading={loading}
      flex={flex}
      leading={leading}
      icon={icon}
      trailing={trailing}
      fullWidth={fullWidth}
      hapticStyle={hapticStyle}
      style={style}
      contentStyle={contentStyle}
      textStyle={textStyle}
    />
  );
}
